import { createRouter, createWebHistory } from "vue-router";

import LoginPage from "@/views/LoginPage.vue";
import SelectRolesPage from "@/views/SelectRolesPage.vue";
import Ticker from "@/views/Ticker.vue";
import AnalyticsPage from "@/views/AnalyticsPage.vue";
import DefaultPage from "@/views/DefaultPage.vue";

const routes = [
  {
    path: "/",
    component: DefaultPage,
    name: "default",
    meta: { title: "" },
  },
  {
    path: "/login",
    component: LoginPage,
    name: "login",
    meta: { title: " | Авторизация" },
  },
  {
    path: "/select-roles",
    component: SelectRolesPage,
    name: "roles",
    meta: { title: " | Выберите должность" },
  },
  {
    path: "/ticker/:id",
    component: Ticker,
    name: "ticker",
  },
  {
    path: "/analytics",
    component: AnalyticsPage,
    name: "analytics",
    meta: { title: " | Аналитика" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// router.beforeEach((to, from, next) => {
//   const token = Boolean(localStorage.getItem('userData'))

//   // Нет токена → на login
//   if (!token && to.path !== '/login') {
//     next('/login')
//     return
//   }

//   // Есть токен
//   if (token) {
//     next()
//   }
// });

export default router;
